module.exports = __webpack_public_path__ + "static/media/S1-22-Orbtralzz-cod42.c0ce8821.png";